(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // === Transparent header: go solid when scrolled away from the very top ===
  // Direction-independent — solid on scroll-down AND scroll-up, transparent only at top.
  (function () {
    const wrapper = document.querySelector('.header-wrapper--transparent');
    if (!wrapper) return;

    const THRESHOLD = 10; // px from top before going solid
    let ticking = false;

    function update() {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > THRESHOLD) {
        wrapper.classList.add('header--solid-scrolled');
      } else {
        wrapper.classList.remove('header--solid-scrolled');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update(); // set correct state on load (e.g. if page loads mid-scroll)
  })();

// === Hover-to-open submenus on desktop (>=990px) ===
(function () {
  const DESKTOP = '(min-width: 990px)';
  const mql = window.matchMedia(DESKTOP);
  const isDesktop = () => mql.matches;

  // Select ALL potential header <details> for menus across Dawn variants
  function getHeaderDetails() {
    // Common containers used by Dawn for inline + mega menus
    return Array.from(document.querySelectorAll(
      [
        '.header details',                    // generic catch-all inside header
        '.header__inline-menu details',       // inline dropdown variant
        'header-menu details',                // custom element wrapper
        '.mega-menu details'                  // older mega menu wrappers
      ].join(', ')
    )).filter(d => d.querySelector('summary') && d.querySelector('summary').nextElementSibling);
  }

  // Close all sibling <details> to avoid multiple open menus
  function closeSiblings(current) {
    const parent = current.parentElement || document;
    parent.querySelectorAll('details[open]').forEach((el) => {
      if (el !== current) el.removeAttribute('open');
    });
  }

  let wired = new Set();
  let leaveTimers = new WeakMap();

  function unWireAll() {
    wired.forEach(d => {
      const summary = d.querySelector('summary');
      if (d.__onEnter) d.removeEventListener('mouseenter', d.__onEnter);
      if (d.__onLeave) d.removeEventListener('mouseleave', d.__onLeave);
      if (summary && summary.__onClick) summary.removeEventListener('click', summary.__onClick);
      if (summary && summary.__onPointerDown) summary.removeEventListener('pointerdown', summary.__onPointerDown);
    });
    wired.clear();
  }

  function wire() {
    unWireAll();
    if (!isDesktop()) return;

    getHeaderDetails().forEach((d) => {
      const summary = d.querySelector('summary');
      if (!summary) return;

      // open quickly on hover/focus
      d.__onEnter = () => {
        const t = leaveTimers.get(d);
        if (t) { clearTimeout(t); leaveTimers.delete(d); }
        closeSiblings(d);
        d.setAttribute('open', '');
      };

      // close when pointer leaves the entire details tree (with tiny delay to allow diagonal moves)
      d.__onLeave = (e) => {
        const to = e.relatedTarget;
        const timer = setTimeout(() => {
          if (!to || !d.contains(to)) d.removeAttribute('open');
        }, 120);
        leaveTimers.set(d, timer);
      };

      // prevent toggling on summary click in desktop (submenu links still work)
      summary.__onClick = (evt) => { if (isDesktop()) evt.preventDefault(); };
      // prevent mousedown from focusing/scrolling to top on some browsers
      summary.__onPointerDown = (evt) => { if (isDesktop()) evt.preventDefault(); };

      d.addEventListener('mouseenter', d.__onEnter);
      d.addEventListener('mouseleave', d.__onLeave);
      summary.addEventListener('click', summary.__onClick);
      summary.addEventListener('pointerdown', summary.__onPointerDown);

      wired.add(d);
    });
  }

  // initial + on breakpoint change + when Shopify re-renders sections
  wire();
  mql.addEventListener('change', wire);
  document.addEventListener('shopify:section:load', wire);
  document.addEventListener('shopify:section:reorder', wire);

  // close on ESC for accessibility
  document.addEventListener('keydown', (e) => {
    if (!isDesktop() || e.key !== 'Escape') return;
    getHeaderDetails().forEach(d => d.removeAttribute('open'));
  });
})();



  } catch(e) { console.error(e); }
})();
})();
